package one.healthium.domain.health_log.models

data class HealthLogOption(
    val questionId: String,
    val answers: List<HealthLogAnswerOption>,
)

data class HealthLogAnswerOption(
    val answerId: String,
    val weight: Int,
)